import styled from "styled-components"
import Overlay from "../../../Componentes/Overlay"
import Modal from "../../../Componentes/Utils/Modal"
import { useModal } from "../../../contexts/ModalContext"
import { useEffect, useState } from "react"
import axios from "axios"
import Tabela from "../../../Componentes/Utils/Tabela"
import ModalAddChecklistModel from "./ModalAddChecklistModel"
import ModalListaItens from "./ModalListaItens"
import { MdEdit } from "react-icons/md";
import { GoTrash } from "react-icons/go";
import ModalDeleteModelo from "./ModalDeleteModelo"

const BotaoAddModelo = styled.button`
    width: 200px;
    height: 40px;
    background-color: #4CAF50;
    color: white;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    border: none;
    border-radius: 5px;
    transition: .3s;
    &:hover {
        background-color: #45a049;
        scale: 1.05;
    }
    margin-left: auto;
    margin-bottom: 10px;
`

const ColunaTabela = styled.td`
    color: #000;
`
const ColunaItens = styled.td`
    width: 120px;
`
const DivAcoes = styled.div`
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`
const IconeEdit = styled(MdEdit)`
    width: 22px;
    height: 22px;
    color: #0000ff;
    cursor: pointer;
    transition: all.3s;
    &:hover{
        scale: 1.1;
    }
`
const IconeApagar = styled(GoTrash)`
    width: 20px;
    height: 20px;
    color: #ff0000;
    cursor: pointer;
    transition: all.3s;
    &:hover{
        scale: 1.1;
    }
`
const StatusDiv = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${ props => props.equipamento ? "green" : "red" };
    margin: auto;
`

const ModalListaModelos = ({ id_tipo }) => {

    const { closeModal, isModalOpen, openModal } = useModal();

    const [modelosList, setModelosList] = useState([])

    const [modeloSelected, setModeloSelected] = useState(null);

    const fetchModelos = async () => {
        try {
            const { data } = await axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GetModelos/index.php?tipoId=${id_tipo}`)
            setModelosList(data)
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        fetchModelos();
    }, [])

    const [itemSelected, setItemSelected] = useState(null);

    const openNewModelo = (item = null) => {
        setItemSelected(item);
        openModal('ModalAddModelo')
    }

    const openDeleteModelo = (item = null) => {
        setItemSelected(item);
        openModal('ModalDeleteModelo');
    }

    const closeModelo = () => {
        setItemSelected(null);
        closeModal();
    }

    const openItensModelo = (modelo) => {
        setModeloSelected(modelo);
        openModal('ModalListaItens');
    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="lg" header={true} close={closeModal} >
                    <BotaoAddModelo onClick={() => openNewModelo()} >NOVO MODELO</BotaoAddModelo>
                    <Tabela>
                        <thead>
                            <tr>
                                <th>MODELO</th>
                                <th>EQUIPAMENTO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {modelosList.map((obj) => (
                                <tr
                                    key={obj.id}
                                    onClick={() => openItensModelo(obj.identifier)}
                                >
                                    <ColunaTabela>{obj.nome}</ColunaTabela>
                                    <ColunaTabela>
                                        <StatusDiv equipamento={ obj.equipamento } />
                                    </ColunaTabela>
                                    <ColunaItens>
                                        <DivAcoes>
                                            <IconeEdit
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openNewModelo(obj);
                                                }}
                                            />
                                            <IconeApagar
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openDeleteModelo(obj);
                                                }}
                                            />
                                        </DivAcoes>
                                    </ColunaItens>
                                </tr>
                            ))}
                        </tbody>
                    </Tabela>
                </Modal>
            </Overlay>
            {isModalOpen('ModalAddModelo') && (
                <ModalAddChecklistModel
                    id_tipo={id_tipo}
                    fetchSuccess={fetchModelos}
                    itemEdit={itemSelected}
                    fecharModelo={closeModelo}
                />
            )}
            {isModalOpen('ModalDeleteModelo')&&(
                <ModalDeleteModelo
                    item={ itemSelected }
                    fetchSuccess={fetchModelos}
                    fecharModelo={closeModelo}
                />
            )}
            {isModalOpen('ModalListaItens') && (
                <ModalListaItens
                    origem="modelo"
                    id_tipo={id_tipo}
                    id_modelo={modeloSelected}
                />
            )}
        </>
    )
}

export default ModalListaModelos;